import * as findConversationShapeUtil from './utils/findConversationShapeUtil';
import BaseFolderId from 'owa-service/lib/contract/BaseFolderId';
import BasePagingType from 'owa-service/lib/contract/BasePagingType';
import FindConversationRequest from 'owa-service/lib/contract/FindConversationRequest';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import SortResults from 'owa-service/lib/contract/SortResults';
import ViewFilter from 'owa-service/lib/contract/ViewFilter';
import findConversationRequest from 'owa-service/lib/factory/findConversationRequest';
import targetFolderId from 'owa-service/lib/factory/targetFolderId';
import ConversationQueryTraversal from 'owa-service/lib/contract/ConversationQueryTraversal';
import findConversationOperation from 'owa-service/lib/operation/findConversationOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import RequestOptions from 'owa-service/lib/RequestOptions';
import FolderId from 'owa-service/lib/contract/FolderId';
import RestrictionType from 'owa-service/lib/contract/RestrictionType';

function configureRequestBody(
    currentFolderId: BaseFolderId,
    paging: BasePagingType,
    viewFilter: ViewFilter,
    sortResults: SortResults[],
    focusedViewFilter: FocusedViewFilter,
    categoryName: string,
    traversal: ConversationQueryTraversal,
    findConversationShapeName: string,
    hashtagsToInclude?: string[],
    hashtagsToExclude?: string[],
    searchFolderId?: BaseFolderId,
    restriction?: RestrictionType
): FindConversationRequest {
    const folderId = currentFolderId as FolderId;
    const requestData: FindConversationRequest = {
        ParentFolderId: targetFolderId({ BaseFolderId: currentFolderId }),
        ConversationShape: findConversationShapeUtil.getFindConversationResponseShape(folderId.Id),
        ShapeName: findConversationShapeName,
        Paging: paging,
        ViewFilter: viewFilter,
        SortOrder: sortResults,
        FocusedViewFilter: focusedViewFilter,
        CategoryFilter: categoryName,
        Traversal: traversal,
    };

    // add optional request parameter
    if (searchFolderId) {
        requestData.SearchFolderId = searchFolderId;
    }

    if (hashtagsToInclude && hashtagsToInclude.length > 0) {
        requestData.HashtagsToInclude = hashtagsToInclude;
    }

    if (hashtagsToExclude && hashtagsToExclude.length > 0) {
        requestData.HashtagsToExclude = hashtagsToExclude;
    }

    if (restriction) {
        requestData.Restriction = restriction;
    }

    return findConversationRequest(requestData);
}

export function findConversation(
    folderId: BaseFolderId,
    paging: BasePagingType,
    viewFilter: ViewFilter,
    sortResults: SortResults[],
    focusedViewFilter: FocusedViewFilter,
    findConversationShapeName: string,
    options: RequestOptions,
    categoryName: string,
    traversal: ConversationQueryTraversal,
    hashtagsToInclude?: string[],
    hashtagsToExclude?: string[],
    searchFolderId?: BaseFolderId,
    restriction?: RestrictionType
): Promise<Response> {
    if (categoryName && viewFilter != 'UserCategory') {
        throw new Error('CategoryName should be set only for UserCategory view filter');
    }

    const requestOptions: RequestOptions = { ...options };
    // We are setting this flag to get the full Response object back from owa-service.
    requestOptions.returnFullResponseOnSuccess = true;

    const requestBody = configureRequestBody(
        folderId,
        paging,
        viewFilter,
        sortResults,
        focusedViewFilter,
        categoryName,
        traversal,
        findConversationShapeName,
        hashtagsToInclude,
        hashtagsToExclude,
        searchFolderId,
        restriction
    );

    const result: any = findConversationOperation(
        {
            Header: getJsonRequestHeader(),
            Body: requestBody,
        },
        requestOptions
    );

    return result as Promise<Response>;
}
